import { render, staticRenderFns } from "./TopicDailyChanges.vue?vue&type=template&id=20a2272a&scoped=true"
import script from "./TopicDailyChanges.vue?vue&type=script&lang=js"
export * from "./TopicDailyChanges.vue?vue&type=script&lang=js"
import style0 from "./TopicDailyChanges.vue?vue&type=style&index=0&id=20a2272a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2272a",
  null
  
)

export default component.exports